package org.example.project.planner.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.client.model.ActivityResponse
import org.example.project.ui.components.AgeBadge
import org.example.project.ui.components.CategoryBadge
import org.example.project.ui.components.DurationBadge
import org.example.project.ui.icons.AppIcons
import org.example.project.ui.theme.LocalPlayfulShapes
import org.example.project.ui.theme.PlayfulColors

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun FavoritesPickerDialog(
    favorites: List<ActivityResponse>,
    onSelect: (ActivityResponse) -> Unit,
    onDismiss: () -> Unit
) {
    val shapes = LocalPlayfulShapes.current

    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(
                    imageVector = AppIcons.StarFilled,
                    contentDescription = null,
                    tint = PlayfulColors.SunYellowDark,
                    modifier = Modifier.size(20.dp)
                )
                Spacer(modifier = Modifier.width(8.dp))
                Text(
                    text = "Wybierz zabawę z ulubionych",
                    fontSize = 17.sp,
                    fontWeight = FontWeight.Bold,
                    color = PlayfulColors.TextPrimary
                )
            }
        },
        text = {
            if (favorites.isEmpty()) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(vertical = 24.dp),
                    contentAlignment = Alignment.Center
                ) {
                    Column(horizontalAlignment = Alignment.CenterHorizontally) {
                        Surface(
                            color = PlayfulColors.SunYellowLight,
                            shape = shapes.pill,
                            modifier = Modifier.size(48.dp)
                        ) {
                            Box(contentAlignment = Alignment.Center) {
                                Icon(
                                    imageVector = AppIcons.StarOutline,
                                    contentDescription = null,
                                    tint = PlayfulColors.SunYellowDark,
                                    modifier = Modifier.size(24.dp)
                                )
                            }
                        }
                        Spacer(modifier = Modifier.height(12.dp))
                        Text(
                            text = "Brak ulubionych zabaw",
                            fontWeight = FontWeight.Bold,
                            fontSize = 15.sp,
                            color = PlayfulColors.TextPrimary
                        )
                        Spacer(modifier = Modifier.height(4.dp))
                        Text(
                            text = "Dodaj zabawy do ulubionych w katalogu gwiazdką, aby móc je tutaj szybko wybrać.",
                            textAlign = TextAlign.Center,
                            fontSize = 12.sp,
                            color = PlayfulColors.TextSecondary
                        )
                    }
                }
            } else {
                LazyColumn(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(340.dp),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    items(favorites, key = { it.id }) { activity ->
                        Card(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable { onSelect(activity) },
                            shape = shapes.cardSmall,
                            colors = CardDefaults.cardColors(containerColor = PlayfulColors.Surface),
                            border = BorderStroke(1.dp, PlayfulColors.BorderSubtle),
                            elevation = CardDefaults.cardElevation(defaultElevation = 1.dp)
                        ) {
                            Column(modifier = Modifier.padding(12.dp)) {
                                Text(
                                    text = activity.name,
                                    fontWeight = FontWeight.Bold,
                                    fontSize = 14.sp,
                                    color = PlayfulColors.TextPrimary
                                )
                                Spacer(modifier = Modifier.height(6.dp))
                                FlowRow(
                                    modifier = Modifier.fillMaxWidth(),
                                    horizontalArrangement = Arrangement.spacedBy(6.dp),
                                    verticalArrangement = Arrangement.spacedBy(4.dp)
                                ) {
                                    CategoryBadge(category = activity.category)
                                    AgeBadge(minAge = activity.minAge, maxAge = activity.maxAge)
                                    DurationBadge(durationMinutes = activity.durationMinutes)
                                }
                            }
                        }
                    }
                }
            }
        },
        confirmButton = {
            TextButton(
                onClick = onDismiss,
                shape = shapes.buttonSmall
            ) {
                Text("Zamknij", fontSize = 13.sp, color = PlayfulColors.TextSecondary)
            }
        },
        shape = shapes.dialog,
        containerColor = PlayfulColors.Surface
    )
}
